import { Phone, CalendarCheck } from "lucide-react";
import { COMPANY } from "@/data/content";

export default function StickyCallBar({ onQuote }) {
  return (
    <div
      data-testid="sticky-call-bar"
      className="lg:hidden fixed bottom-0 inset-x-0 z-50 bg-black/90 backdrop-blur-xl border-t border-white/10 grid grid-cols-2"
    >
      <a
        href={`tel:${COMPANY.phoneRaw}`}
        data-testid="sticky-call-link"
        className="flex items-center justify-center gap-2 py-4 text-white font-semibold border-r border-white/10"
      >
        <Phone className="w-5 h-5 text-honey" /> Call Now
      </a>
      <button
        onClick={onQuote}
        data-testid="sticky-quote-btn"
        className="flex items-center justify-center gap-2 py-4 bg-honey text-white font-bold"
      >
        <CalendarCheck className="w-5 h-5" /> Free Quote
      </button>
    </div>
  );
}
